import Component_PBRConfiguration_386f1854d61cc0f1e45264a2946996e3 from "../../../../content/examples/textures/pbr-configuration/PBRConfiguration";
import Devtool_PBRConfiguration_386f1854d61cc0f1e45264a2946996e3 from "!!@devtool/loader!../../../../content/examples/textures/pbr-configuration/PBRConfiguration";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_PBRConfiguration_386f1854d61cc0f1e45264a2946996e3,
  Devtool_PBRConfiguration_386f1854d61cc0f1e45264a2946996e3,
  DevTool,
  React
};